export const encodeURL = (url) => {
    if (!url) return;
    return url.replace(/\s/g, '_').replace(/\?/g, '');
};
